import React from 'react';

import ImageCard from './ImageCard';
import {
  Grid,
  GridItem,
  Heading,
  Lines,
} from './styled-components';

const ImageCardGrid = ({ title, items }) => {

  return (
    <div>
      <Heading><Lines>{title}</Lines></Heading>
      { items && 
        <Grid>
        {items.map((item, index) => 
          <GridItem key={index} count={items.length}>
            <ImageCard {...item}></ImageCard>
          </GridItem>)}
        </Grid>
      }
    </div>
  );
}

ImageCardGrid.defaultProps = {
  title: 'Merino Runners',
  items: [
    {
      image: 'https://picsum.photos/600/400',
      cardLink: false,
      title: 'Merino Runners',
      url: '',
    },
    {
      image: 'https://picsum.photos/600/400',
      cardLink: false,
      title: 'Merino Runners',
      url: 'http://google.com',
    },
    {
      image: 'https://picsum.photos/600/400',
      cardLink: true,
      title: 'Merino Runners',
      url: 'http://google.com',
    }
  ]
}

export default ImageCardGrid;